import React, { useState } from "react";

import { TableRow, TableCell } from "@material-ui/core";

import { stableSort, getComparator } from "App/Component/ui/datatable/utils";

import {
  TableWrapper,
  TableAction,
  ModalDeleteConfirm,
  TableCellDefault,
} from "App/Component/ui";

import { STYLE_DEFAULT_MASTER } from "App/constants/theme";

import { useFetch, useDatatables } from "App/hooks";
import {
  ModalForm,
  headCells,
  deletePoliklinikSpesialisById,
  RESET_STATE_POLIKLINIK_SPESIALIS,
} from "./helpers";
import { TYPE_INSTANCE1 } from "App/constants";
import { LIST_URL_MASTER } from "utils/masters";

export default function PoliklinikSpesialis() {
  const classes = STYLE_DEFAULT_MASTER();

  const [showModal, setShowModal] = useState(false);
  const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false);

  const [rows, setRows] = useFetch(
    TYPE_INSTANCE1,
    LIST_URL_MASTER.poliklinik_spesialis.list
  );
  const [formData, setFormData] = useState(RESET_STATE_POLIKLINIK_SPESIALIS);

  const {
    page,
    setQ,
    setPage,
    setRowsPerPage,
    data,
    order,
    orderBy,
    handleRequestSort,
    length,
    rowsPerPage,
  } = useDatatables({
    rows: rows,
    orderByDefault: "poli_room_code",
    orderByRow: ["poli_room_code", "spec_code"],
  });

  function clickAdd() {
    setFormData(RESET_STATE_POLIKLINIK_SPESIALIS);
    setShowModal(!showModal);
  }

  function clickUpdate(row) {
    setFormData({
      id: row?.id,
      poli_room_code: row?.poli_room_code,
      poli_name: row?.poli_name,
      spec_code: row?.spec_code,
      spec_name: row?.spec_name,
      remark: row?.remark,
    });

    setShowModal(true);
  }

  function clickDelete(row) {
    setFormData({
      ...formData,
      id: row?.id,
    });
    setShowModalDeleteConfirm(!showModalDeleteConfirm);
  }

  return (
    <div className={classes.root}>
      {showModal && (
        <ModalForm
          setRows={setRows}
          setShowModal={() => setShowModal(false)}
          formData={formData}
          setFormData={setFormData}
        />
      )}

      {showModalDeleteConfirm && (
        <ModalDeleteConfirm
          confirmHandle={() =>
            deletePoliklinikSpesialisById(
              formData.id,
              setRows,
              setShowModalDeleteConfirm,
              setFormData
            )
          }
          setShowModalDeleteConfirm={() => setShowModalDeleteConfirm(false)}
        />
      )}

      <TableWrapper
        title='Daftar Poliklinik Spesialis'
        setQ={setQ}
        clickAddButton={() => clickAdd()}
        withExportButton={false}
        order={order}
        orderBy={orderBy}
        handleRequestSort={handleRequestSort}
        length={length}
        rows={rows}
        headCells={headCells}
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}>
        {stableSort(data, getComparator(order, orderBy))
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map((row, index) => {
            return (
              <TableRow
                hover
                tabIndex={-1}
                key={index}
                style={{
                  backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
                }}>
                <TableCell
                  component='th'
                  scope='row'
                  padding='none'
                  align='center'>
                  {index + 1}
                </TableCell>

                <TableCell
                  component='th'
                  scope='row'
                  padding='none'
                  align='center'>
                  <TableAction
                    clickDelete={() => clickDelete(row)}
                    clickUpdate={() => clickUpdate(row)}
                  />
                </TableCell>
                <TableCell align='left'>{row?.poli_name}</TableCell>
                <TableCell align='left'>{row?.spec_name}</TableCell>
                <TableCell align='left'>{row?.remark}</TableCell>
                <TableCellDefault row={row} />
              </TableRow>
            );
          })}
      </TableWrapper>
    </div>
  );
}
